import { createContext } from "react";
const DealOfTheDayContext = createContext({});

export default DealOfTheDayContext;
